// Phase 6 — Track B T-B5. Error copy.
//
// Maps backend error codes (the `error.code` envelope field — see auth
// routes, alerts router, dashboard router, etc.) to friendly user-facing
// messages. The web layer pipes ApiError.code through this table; codes the
// table does not know about fall back to `unknown`.
//
// Per blueprint §13.4: errors are stated as facts, never blame the user,
// and never carry punctuation flourishes ("Try again" rather than "Try
// again!"). Periods at the end of full sentences are fine; exclamation
// marks, emoji, and "Oops!"-style copy are not.

export const errorsCopy = {
  // Auth
  invalid_credentials: 'Email or password is incorrect.',
  email_already_registered: 'That email is already registered.',
  refresh_invalid: 'Your session expired. Sign in again.',
  refresh_replay_detected:
    'For your security, we ended every session on this account. Sign in again.',
  token_mode_unavailable: 'Token mode is not available right now.',

  // Body / query envelope
  invalid_body: 'Some fields need attention.',
  invalid_query: 'The filter you applied is not valid.',
  invalid_path: 'That address is not valid.',

  // Network / transport
  network_unavailable: 'You appear to be offline. Reconnect and try again.',
  server_error: 'Something went wrong on our side. Try again in a moment.',
  unknown: 'Something went wrong. Try again in a moment.',

  // Phase 6 — Track F T-F3. ErrorBoundary fallback title.
  fallback_title: 'Something went wrong.',
} as const;

export type ErrorCode = keyof typeof errorsCopy;

export function lookupErrorCopy(code: string | null | undefined): string {
  if (code !== null && code !== undefined && code in errorsCopy) {
    return errorsCopy[code as ErrorCode];
  }
  return errorsCopy.unknown;
}
